import React from "react";
import { PropTypes } from "prop-types";
import { Accordion } from "../_accordion/Accordion.js";
import "./_faqs.scss";

export const Faqs = ({ title, children }) => {
  // const childrenArray = Object.values(children);

  return (
    <div className="faqs">
      <span className="h3">{title}</span>
      <Accordion children={children} />
    </div>
  );
};

Faqs.propTypes = {
  title: PropTypes.string.isRequired,
};
